import React from 'react'
import {PolicyListToolbar} from '../header/PolicyListToolbar'
import {FileItemType} from '../../Utils/PolicyUtils'
import Searchbar from 'app/components/Searchbar'

type CardHeaderProps = {
  searchTerm: string
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>
  selectedStatus: string
  isChecked: boolean
  selectedItems: string[]
  policies: FileItemType[]
  handleApplyFilter: (e: React.ChangeEvent<HTMLSelectElement>) => void
  handleDeselectClick: () => void
  handleAssignOwnerClick: () => void
  currentAuditContext?: any
  currentUser?: any
}

const CardHeader: React.FC<CardHeaderProps> = ({
  searchTerm,
  setSearchTerm,
  selectedStatus,
  isChecked,
  selectedItems,
  policies,
  handleApplyFilter,
  handleDeselectClick,
  handleAssignOwnerClick,
  currentAuditContext,
  currentUser,
}) => {
  return (
    <div className='card-header border-0 pt-6 h-100'>
      <div className='card-title'>
        <div className='flex-lg-fill'>
          <Searchbar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        </div>
      </div>
      <div className='card-toolbar'>
        <div className='d-flex justify-content-end' data-kt-user-table-toolbar='base'>
          {isChecked ? (
            <>
                     <div style={{display: 'flex', alignItems: 'center'}}>
              {selectedItems.length > 0 && (
                <div className='border-end px-4 text-center' style={{color: '#A1A5B7'}}>
                  <span>
                    <p className='pt-3 fw-semibold fs-6'>{selectedItems.length} Selected</p>
                  </span>
                </div>
              )}
             
              <div className='mx-5' style={{cursor: 'pointer'}} onClick={handleDeselectClick}>
                  <img src='/media/buttons/Deselect.svg' alt='Deselect' />
                </div>
              <button
                type='button'
                className='btn btn-sm fs-6 fw-bold'
                style={{backgroundColor: '#0E9F6E', color: '#FFFFFF', height: '40px'}}
                onClick={handleAssignOwnerClick}
                disabled={currentAuditContext || currentUser?.role === 'Auditor'}
              >
                Assign Owner
              </button>
              </div>
            </>
          ) : (
            <>
              <div className='d-flex align-items-center justify-content-end'>
                <span className='fs-6 fw-semibold mx-4'>Status:</span>
                <select
                  id='status'
                  className='form-select me-4'
                  aria-label='Select Status'
                  value={selectedStatus}
                  style={{width: '70%', height: '40px'}}
                  onChange={handleApplyFilter}
                >
                  <option value=''>All</option>
                  <option value='Approved'>Approved</option>
                  <option value='Needs approval'>Needs approval</option>
                  <option value='Needs review'>Needs review</option>
                  <option value='Incomplete'>Incomplete</option>
                </select>
              </div>
              <PolicyListToolbar policies={policies} currentAuditContext={currentAuditContext} />
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default CardHeader
